import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import ImageShape from "%/dynamic-component-editor/options/image-shape";
import ObjectPosition from "%/dynamic-component-editor/options/object-position";
import FallbackImage from "%/dynamic-component-editor/options/fallback-image";
import ImageAltText from "%/dynamic-component-editor/options/image-alt-text";
import ImageFillBackground from "%/dynamic-component-editor/options/image-fill-background";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import Crop from "%/dynamic-component-editor/options/crop";
import Blur from "%/dynamic-component-editor/options/blur";
import Brightness from "%/dynamic-component-editor/options/brightness";
import Contrast from "%/dynamic-component-editor/options/contrast";
import Grayscale from "%/dynamic-component-editor/options/grayscale";
import HueRotate from "%/dynamic-component-editor/options/hue-rotate";
import Invert from "%/dynamic-component-editor/options/invert";
import ImageOpacity from "%/dynamic-component-editor/options/opacity";
import Saturate from "%/dynamic-component-editor/options/saturate";
import Sepia from "%/dynamic-component-editor/options/sepia";
import BlendMode from "%/dynamic-component-editor/options/blend-mode";
import Rendering from "%/dynamic-component-editor/options/rendering";
import ClipPath from "%/dynamic-component-editor/options/clip-path";

export default class FallbackImageOptions extends BaseOptionsBundle {

  optionTitle = "Fallback Image";
  static optionClassName = "i-dynamic-image";
  inspectorToolGroup = "image";
  useInspectorLabel = false;
  static userInterfaceComponent = {
    component: inspectorTools.IMAGE_TOOLSET,
  };

  constructor(values = {}, hideFromInspector = {}) {
    super(values, [
      new FallbackImage(undefined, hideFromInspector["fallback-image"] ?? false),
      new ImageAltText(undefined, hideFromInspector["image-alt-text"] ?? false),
      new ImageShape(undefined, hideFromInspector["image-shape"] ?? false),
      new ObjectPosition(undefined, hideFromInspector["object-position"] ?? false),
      new ImageFillBackground(undefined, hideFromInspector["image-fill-background"] ?? false),
      new Crop(undefined, hideFromInspector["crop"] ?? false),

      // Effect Options
      Blur,
      Brightness,
      Contrast,
      Grayscale,
      HueRotate,
      Invert,
      ImageOpacity,
      Saturate,
      Sepia,
      BlendMode,
      Rendering,
      ClipPath,
    ]);
  }
}
